// Visual constants for the Pipeline page — kept close to consumers so the
// page module file stays a thin orchestrator.
import { FileDoc, ShoppingCart, Receipt, HandCoins, UsersThree } from "@phosphor-icons/react";

export const STAGE_VISUAL = {
    lead: { Icon: UsersThree, color: "from-violet-500 to-violet-600", text: "text-violet-700", ring: "border-violet-200" },
    proposal: { Icon: FileDoc, color: "from-indigo-500 to-indigo-600", text: "text-indigo-700", ring: "border-indigo-200" },
    po_finalized: { Icon: ShoppingCart, color: "from-amber-500 to-amber-600", text: "text-amber-700", ring: "border-amber-200" },
    invoiced: { Icon: Receipt, color: "from-slate-700 to-slate-900", text: "text-slate-900", ring: "border-slate-300" },
    paid: { Icon: HandCoins, color: "from-emerald-500 to-emerald-600", text: "text-emerald-700", ring: "border-emerald-200" },
};

export const STAGE_LABEL = {
    lead: "Lead",
    proposal: "Proposal",
    po_created: "PO created",
    po_finalized: "PO finalized",
    invoiced: "Invoiced",
    paid: "Paid",
};

export const EMPTY_FILTERS = {
    date_from: "",
    date_to: "",
    sales_rep: "",
    state_code: "",
    segment: "",
    gst_type: "",
    module_code: "",
};
